module.exports = __webpack_public_path__ + "static/media/LightBulbGreen.2ea2f7ff.svg";